export default __webpack_public_path__ + "static/media/symmetra-intro.4cfb7b6e.mp3";